export enum ParticipantEvents {
  UPDATED = "ParticipantUpdated"
}
